const theme = {
    background: "transparent",
    text: {
        fontSize: "0.8rem",
        fill: '#333333'
    },
    axis: {
        domain: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            }
        },
        legend: {
            text: {
                fontSize: "1rem",
            }
        },
        ticks: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            },
            text: {
                fontSize: "0.85rem",
            }
        }
    },
    grid: {
        line: {
            stroke: "#dddddd",
            strokeWidth: 1
        }
    },
    legends: {
        text: {
            fontSize: "1rem",
        }
    },
    tooltip: {
        container: {
            background: "rgba(255,255,255, 0.8)",
            color: "#333333",
            fontSize: "0.85rem",
        }
    }
};

export default theme;